import { Injectable } from '@angular/core';
import { FormArray, FormGroup, ValidationErrors } from '@angular/forms';
import { Subject } from 'rxjs';
import { ErroresForm } from '../models/firmante-nif';
import { FormularioDocumentoService } from './formulario-documento.service';

@Injectable({
  providedIn: 'root'
})
export class FormularioValidacionesDocsService {

  /** Emite cuando cambian errores/touched de nombres de formulario (p. ej. al pulsar Finalizar). */
  private readonly validacionFormulariosRevisionSubject = new Subject<void>();
  readonly validacionFormulariosRevision$ = this.validacionFormulariosRevisionSubject.asObservable();

  mensajeErrorNombre: string = '';
  mensajeErrorCifPage: string = '';
  mensajeErrorCifOrden: string = '';
  mensajeErrorCifFormulario: string = '';
  mensajeErrorCifPosicion: string = '';
  mensajeErrorNifPage: string = '';
  mensajeErrorNifOrden: string = '';
  mensajeErrorNifFormulario: string = '';
  mensajeErrorTipoFirma: string = '';
  mensajeErrorTieneTag: string = '';
  mensajeErrorNombreTag: string = '';
  mensajeErrorPosicionFirmas: string = '';
  mensajeErrorNombreFormulario: string = '';
  mensajeErrorGenerico: string = '';
  mensajeErrorNombreArchivoFirmado: string = '';
  mensajeErrorNombreArchivoAudit: string = '';
  mensajeErrorSplit: string = '';
  mensajeErrorCopiaBasica: string = '';
  mensajeErrorTextoFormulario: string = '';
  mensajeErrorTextoAExcluirFormulario: string = '';
  mensajeErrorPosicionNif: string = '';

  constructor(private formularioDocumentoService: FormularioDocumentoService) { }

  get nombre(){ return this.formularioDocumentoService.formularioDocumento.controls['nombre']}
  get cifPage(){ return this.formularioDocumentoService.formularioDocumento.controls['cifPage']}
  get cifOrden(){ return this.formularioDocumentoService.formularioDocumento.controls['cifOrden']}
  get cifFormulario(){ return this.formularioDocumentoService.formularioDocumento.controls['cifFormulario']}
  get posicionCif(){ return this.formularioDocumentoService.formularioDocumento.controls['posicionCif']}
  get firmantesNif(){return this.formularioDocumentoService.formularioDocumento.get('firmantesNif') as FormArray}
  get generico(){return this.formularioDocumentoService.formularioDocumento.controls['generico']}
  get formatoNombreArchivoFirmado(){return this.formularioDocumentoService.formularioDocumento.controls['formatoNombreArchivoFirmado']}
  get formatoNombreArchivoAuditTrail(){return this.formularioDocumentoService.formularioDocumento.controls['formatoNombreArchivoAuditTrail']}
  get split(){return this.formularioDocumentoService.formularioDocumento.controls['split']}
  get esCopiaBasica(){return this.formularioDocumentoService.formularioDocumento.controls['esCopiaBasica']}
  get textoFormulario(){return this.formularioDocumentoService.formularioDocumento.controls['textoFormulario']}
  get textoAExcluirFormulario(){return this.formularioDocumentoService.formularioDocumento.controls['textoAExcluirFormulario']}


  //comprobamos los errores antes de enviar el formulario y montamos el mensaje de error.
  isCampoValido(campo:string){
      switch(campo){
        case 'nombre':
            if(this.nombre.errors?.nombreVacio)
            this.mensajeErrorNombre = 'Indique el nombre del documento'
            if(this.nombre.errors?.nombreExiste)
            this.mensajeErrorNombre = 'El nombre del documento ya existe.'
            if(this.nombre.errors?.pattern)
            this.mensajeErrorNombre = 'El apóstrofo es un carácter inválido, se debe eliminar antes de continuar.'
            if(this.nombre.errors?.maxlength)
            this.mensajeErrorNombre = 'El nombre es demasiado largo, puede contener 250 caracteres como máximo.'
          break;
        case 'cifPage':
          if(this.cifPage.errors?.validadoresCifRequired){
            this.mensajeErrorCifPage = `El número de página es requerido.`
          }
          if(this.cifPage.errors?.validadoresCifTotalPages){
            this.mensajeErrorCifPage = `El número de página tiene que ser mayor que 0 y menor o igual a ${this.formularioDocumentoService.totalPages}.`
          }
          break;
        case 'cifOrden':
          if(this.cifOrden.errors?.validadoresCifRequired){
            this.mensajeErrorCifOrden = `El número de orden es requerido.`
          }
          if(this.cifOrden.errors?.validadoresCifOrdenMin){
            this.mensajeErrorCifOrden = `El número de orden tiene que ser mayor que 0.`
          }
          break;
        case 'cifFormulario':
          if(this.cifFormulario.errors?.validadoresCifFormulario){
            this.mensajeErrorCifFormulario = 'El nombre del formulario es requerido.'
          }
          break;
        case 'posicionCif':
          if(this.posicionCif.errors?.validadoresCifPosicion){
            this.mensajeErrorCifPosicion = 'Debe seleccionar el cif por página/orden o por formulario.'
          }
          break;
        case 'generico':
          if(this.generico.errors?.validadorGenerico){
            this.mensajeErrorGenerico = 'Seleccione una opción'
          }
          break;
        case 'formatoNombreArchivoFirmado':
          if(this.formatoNombreArchivoFirmado.errors?.validatorsArchivoFirmado){
            this.mensajeErrorNombreArchivoFirmado = 'La información específica incluida en el nombre del documento debe seguir el formato siguiente y debe acabar en ".pdf". Valores: {CODIGO_EMPRESA} {CODIGO_CENTRO} {CODIGO_EMPLEADO} {NOMBRE_EMPLEADO} {APELLIDO1_EMPLEADO} {APELLIDO2_EMPLEADO} {NIF_EMPLEADO} {EMAIL_EMPLEADO} {TELEFONO_EMPLEADO} {NOMBRE_DOCUMENTO} {FECHA_CONTRATO} {ID_TIPO_DOCUMENTO} {NOMBRE_TIPO_DOCUMENTO} {ID_TIPO_ENVIO} {NOMBRE_TIPO_ENVIO}'
          }
          if(this.formatoNombreArchivoFirmado.errors?.validatorsArchivoDuplicado){
            this.mensajeErrorNombreArchivoFirmado = 'El documento debe tener un nombre diferente al del audit.'
          }

          break;
        case 'formatoNombreArchivoAuditTrail':
          if(this.formatoNombreArchivoAuditTrail.errors?.validatorsArchivoAudit){
            this.mensajeErrorNombreArchivoAudit = 'La información específica incluida en el nombre del audit debe seguir el formato siguiente y debe acabar en ".pdf". Valores: {CODIGO_EMPRESA} {CODIGO_CENTRO} {CODIGO_EMPLEADO} {NOMBRE_EMPLEADO} {APELLIDO1_EMPLEADO} {APELLIDO2_EMPLEADO} {NIF_EMPLEADO} {EMAIL_EMPLEADO} {TELEFONO_EMPLEADO} {NOMBRE_DOCUMENTO} {FECHA_CONTRATO} {ID_TIPO_DOCUMENTO} {NOMBRE_TIPO_DOCUMENTO} {ID_TIPO_ENVIO} {NOMBRE_TIPO_ENVIO}';
          }
          if(this.formatoNombreArchivoAuditTrail.errors?.validatorsArchivoDuplicado){
            this.mensajeErrorNombreArchivoAudit = 'El audit debe tener un nombre diferente al del documento.'
          }
          break;
        case 'split':
          if(this.split.errors?.validatorsSplit){
            this.mensajeErrorSplit = `Indique separado por comas (",") los valores a partir de los que desea hacer el desglose (2,...,${this.formularioDocumentoService.totalPages})`
          }
          if(this.split.errors?.maxlength)
            this.mensajeErrorSplit = 'Cadena de texto demasiado larga, puede contener 50 caracteres como máximo.'
          break;
        case 'esCopiaBasica':
          if(this.esCopiaBasica.errors?.validatorsCopiaBasica){
            this.mensajeErrorCopiaBasica = 'Un documento genérico no puede ser copia básica, por favor tire para atrás y cambie la identificación del firmante principal o deschequee copia básica'
          }
          break;
        case 'textoFormulario':
          if(this.textoFormulario.errors?.maxlength){
            this.mensajeErrorTextoFormulario = 'Texto demasiado largo, puede contener 200 caracteres como máximo.'
          }
          break;
        case 'textoAExcluirFormulario':
          if(this.textoAExcluirFormulario.errors?.maxlength){
            this.mensajeErrorTextoAExcluirFormulario = 'Texto demasiado largo, puede contener 200 caracteres como máximo.'
          }
          break;
      }
      if(this.formularioDocumentoService.formularioDocumento.controls[campo]){
        return this.formularioDocumentoService.formularioDocumento.controls[campo].errors && this.formularioDocumentoService.formularioDocumento.controls[campo].touched;
      }else{
        return true;
      }
  }

  //comprobamos los errores del firmanteArrayForm antes de enviar el fomulario y montamos los mensajes de error
  isCampoValidoArray(campo: string, index: number){
    if(this.formularioDocumentoService.firmantesNif.controls[index]){
      let posicionNif = this.formularioDocumentoService.firmantesNif.controls[index].get('posicionNif');
      let nifPage = this.formularioDocumentoService.firmantesNif.controls[index].get('nifPage');
      let nifOrden = this.formularioDocumentoService.firmantesNif.controls[index].get('nifOrden');
      let nifFormulario = this.formularioDocumentoService.firmantesNif.controls[index].get('nifFormulario');
      let firmas = this.formularioDocumentoService.firmantesNif.controls[index].get('firmas');
      switch(campo){
        case 'posicionNif':
          if(posicionNif.errors?.validadoresPosicionNifRequired){
            this.mensajeErrorPosicionNif = 'Seleccione una opción (página/orden o formulario) o desmarque el firmante seleccionado.'
          }
          break;
        case 'nifPage':
            if(nifPage.errors?.validadoresNifRequired){
              this.mensajeErrorNifPage = 'Los dos valores son requeridos.';
              return true;
            }
            if(nifPage.errors?.validadoresNifTotalPages){
              this.mensajeErrorNifPage = `El número de página tiene que ser mayor que 0 y menor o igual a ${this.formularioDocumentoService.totalPages}.`;
              return true;
            }
            if(nifPage.errors?.validadoresNifduplicado){
              this.mensajeErrorNifPage = `No puede haber dos firmantes con el mismo Nif.`;
              return true;
            }
          break;
        case 'nifOrden':
          if(nifOrden.errors?.validadoresNifRequired){
            // this.mensajeErrorNifOrden = `Los dos valores son requeridos.`;
            return true;
          }
          if(nifOrden.errors?.validadoresNifMin){
            this.mensajeErrorNifOrden = `El número de orden tiene que ser mayor que 0.`;
            return true;
          }
          if(nifOrden.errors?.validadoresNifduplicado){
            this.mensajeErrorNifOrden = '';
            return true;
          }
          break;
        case 'nifFormulario':
          if(nifFormulario.errors?.validadoresNifFormulario){
            this.mensajeErrorNifFormulario = `El nombre del formulario es requerido.`;
            return true;
          }
          if(nifFormulario.errors?.validadoresFormularioNifduplicado){
            this.mensajeErrorNifFormulario = `No puede haber dos firmantes con el mismo Formulario.`;
            return true;
          }
          break;
        case 'firmas':
          if(firmas.errors?.validadoresTipoFirmaRequired)
            this.mensajeErrorTipoFirma = 'Seleccione una opción.';
          if(firmas.errors?.validadoresRLTSinFirma)
            this.mensajeErrorTipoFirma = 'No se puede seleccionar "Sin Firma" en un documento RLT.';
          if(firmas.errors?.validadoresTagRequired)
            this.mensajeErrorTieneTag = 'Seleccione una opción.';
          if(firmas.errors?.validadoresNombreTagRequired)
            this.mensajeErrorNombreTag = `Nombre del tag requerido.`;
          if(firmas.errors?.validadoresPosicionFirmasRequired)
            this.mensajeErrorPosicionFirmas = `Se necesita añadir como mínimo una firma.`;
          if(firmas.errors?.validadoresNombreTagTieneEspacios)
            this.mensajeErrorNombreTag = `El nombre del TAG no puede contener espacios. Revisa también que no haya espacios al principio o final del nombre.`;
          if(firmas.errors?.validadoresNombreTagLargo)
            this.mensajeErrorNombreTag = `El nombre del TAG no puede contener más de 200 caracteres.`;
          return !!(firmas.errors && firmas.touched);
      }
      return this.formularioDocumentoService.firmantesNif.controls[index].get(campo)?.errors && this.formularioDocumentoService.firmantesNif.controls[index].get(campo)?.touched;
    }else{
      return true
    }
  }

  getFormValidationErrors(): ErroresForm[]{
    let erroresForm: ErroresForm[] = [];
    let objetoError: ErroresForm;
    this.firmantesNif.controls.forEach((x, index) => {
      let controlKey = this.firmantesNif.controls[index] as FormGroup;
      Object.keys(controlKey.controls).forEach((key:string) => {
        const controlErrors: ValidationErrors = controlKey.get(key).errors;
        if (controlErrors != null) {
          Object.keys(controlErrors).forEach(keyError => {

          objetoError = {firmante: x.value.tipoFirmante, error: keyError}
          erroresForm.push(objetoError);
          });
        }
      });
      if(controlKey.controls['formularios'].value.length > 0){
        let formularioKey = controlKey.controls['formularios'] as FormArray;
        Object.keys(formularioKey.controls).forEach((keyF:string)=>{
          const controlFormularioErrors: ValidationErrors = formularioKey.get(keyF).errors;
          if (controlFormularioErrors != null) {
            Object.keys(controlFormularioErrors).forEach(keyError => {
            objetoError = {firmante: x.value.tipoFirmante, error: keyError}
            erroresForm.push(objetoError);
            });
          }
        })
      }
    })
    return erroresForm;
  }

  private isCampoValidoArrayFormularios(formulario: FormGroup): boolean {
    const nombreControl = formulario?.get('nombre');
    if (!nombreControl) return false;

    if (nombreControl.errors?.nombreFormularioExiste || formulario.errors?.nombreFormularioExiste) {
      this.mensajeErrorNombreFormulario = 'El nombre del formulario ya existe.';
    }
    if (nombreControl.errors?.maxlength) {
      this.mensajeErrorNombreFormulario = 'El nombre del formulario no puede superar los 22 caracteres.';
    }
    if (
      formulario.errors?.nombreFormularioExisteEntreFirmantes ||
      nombreControl.errors?.nombreFormularioExisteEntreFirmantes
    ) {
      const etiqueta = this.obtenerEtiquetaFirmanteConflicto(formulario);
      this.mensajeErrorNombreFormulario = etiqueta
        ? `Este nombre ya lo usa ${etiqueta}.`
        : 'El nombre del formulario ya existe en otro firmante.';
    }
    return !!(
      (formulario.errors || nombreControl.errors) &&
      (nombreControl.touched || formulario.touched)
    );
  }

  isCampoValidoArrayFormulariosCombinado(formulario: FormGroup, indexNif: number): boolean {
    // El borde rojo / mensaje solo deben aparecer cuando el usuario ya ha interactuado
    // con el campo (touched). Recien abierto el formulario, el borde es normal.
    const nombreControl = formulario?.get('nombre');
    const interactuado = !!(nombreControl?.touched || formulario?.touched);
    if (!interactuado) {
      return false;
    }
    const invalidoArray = this.isCampoValidoArrayFormulariosPorFormulario(formulario, indexNif);
    const invalidoNombre = this.isCampoValidoArrayFormularios(formulario);
    return invalidoArray || invalidoNombre;
  }

  actualizarErroresNombreFormularioDuplicado(indexNif: number): void {
    const borradores = this.getBorradorGruposPorFirmante(indexNif);
    if (borradores.length === 0) {
      return;
    }

    borradores.forEach((formulario) => {
      const nombreControl = formulario.get('nombre');
      if (!nombreControl) return;

      const hayDuplicado = this.hayNombreFormularioDuplicadoEnBorradores(formulario, borradores);
      if (hayDuplicado) {
        this.addError(nombreControl, 'nombreFormularioExiste');
        this.addError(formulario, 'nombreFormularioExiste');
      } else {
        this.removeError(nombreControl, 'nombreFormularioExiste');
        this.removeError(formulario, 'nombreFormularioExiste');
      }
    });

    // No llamar updateValueAndValidity aqui: re-ejecuta validadores y borra los
    // errores manuales (nombreFormularioExiste*) asignados con setErrors.
  }

  /**
   * Marca duplicados de nombre de formulario entre firmantes distintos (borradores
   * del documento activo). Se ejecuta tras la validacion intra-firmante.
   */
  actualizarErroresNombreFormularioDuplicadoEntreFirmantes(): void {
    const borradores = this.getTodosLosBorradores();
    borradores.forEach((formulario) => {
      const nombreControl = formulario.get('nombre');
      if (nombreControl) {
        this.removeError(nombreControl, 'nombreFormularioExisteEntreFirmantes');
      }
      this.removeError(formulario, 'nombreFormularioExisteEntreFirmantes');
    });

    const porNombre = new Map<string, FormGroup[]>();
    borradores.forEach((formulario) => {
      const nombreNorm = this.normalizarNombreFormulario(formulario.get('nombre')?.value);
      const codigo = formulario.get('firmante')?.value?.codigo;
      if (!nombreNorm || !codigo) {
        return;
      }
      const lista = porNombre.get(nombreNorm) ?? [];
      lista.push(formulario);
      porNombre.set(nombreNorm, lista);
    });

    porNombre.forEach((formularios) => {
      const codigos = new Set(
        formularios.map(fg => fg.get('firmante')?.value?.codigo).filter(Boolean)
      );
      if (codigos.size <= 1) {
        return;
      }
      formularios.forEach((formulario) => {
        const nombreControl = formulario.get('nombre');
        if (nombreControl) {
          this.addError(nombreControl, 'nombreFormularioExisteEntreFirmantes');
        }
        this.addError(formulario, 'nombreFormularioExisteEntreFirmantes');
      });
    });

    // No llamar updateValueAndValidity aqui (ver actualizarErroresNombreFormularioDuplicado).
  }

  refrescarErroresNombreFormularioDuplicadoGlobal(): void {
    this.formularioDocumentoService.firmantesNif.controls.forEach((_, index) => {
      this.actualizarErroresNombreFormularioDuplicado(index);
    });
    this.actualizarErroresNombreFormularioDuplicadoEntreFirmantes();
  }

  hayErroresNombreFormularioDuplicadoGlobal(): boolean {
    return this.formularioDocumentoService.formulariosBorradorFormArray.controls.some((control) => {
      const formulario = control as FormGroup;
      const nombreControl = formulario.get('nombre');
      return this.tieneErrorNombreFormularioDuplicado(formulario, nombreControl);
    });
  }

  hayErroresNombreFormularioDuplicadoEntreFirmantes(): boolean {
    return this.formularioDocumentoService.formulariosBorradorFormArray.controls.some((control) => {
      const formulario = control as FormGroup;
      const nombreControl = formulario.get('nombre');
      return !!(
        formulario.errors?.nombreFormularioExisteEntreFirmantes ||
        nombreControl?.errors?.nombreFormularioExisteEntreFirmantes
      );
    });
  }

  tieneNombreFormularioDuplicadoEntreFirmantes(formulario: FormGroup): boolean {
    const nombreControl = formulario.get('nombre');
    return !!(
      formulario.errors?.nombreFormularioExisteEntreFirmantes ||
      nombreControl?.errors?.nombreFormularioExisteEntreFirmantes
    );
  }

  obtenerEtiquetaFirmanteConflicto(formulario: FormGroup): string | null {
    const nombreNorm = this.normalizarNombreFormulario(formulario.get('nombre')?.value);
    const codigoActual = formulario.get('firmante')?.value?.codigo;
    if (!nombreNorm || !codigoActual) {
      return null;
    }

    const conflicto = this.getTodosLosBorradores().find((otro) => {
      const otroCodigo = otro.get('firmante')?.value?.codigo;
      if (!otroCodigo || otroCodigo === codigoActual) {
        return false;
      }
      return this.normalizarNombreFormulario(otro.get('nombre')?.value) === nombreNorm;
    });

    return conflicto?.get('firmante')?.value?.desc ?? null;
  }

  marcarNombresFormularioDuplicadosComoTouched(): void {
    this.formularioDocumentoService.formulariosBorradorFormArray.controls.forEach((control) => {
      const formulario = control as FormGroup;
      const nombreControl = formulario.get('nombre');
      if (!this.tieneErrorNombreFormularioDuplicado(formulario, nombreControl)) {
        return;
      }
      formulario.markAsTouched();
      nombreControl?.markAsTouched();
    });
    this.notificarValidacionFormulariosActualizada();
  }

  private notificarValidacionFormulariosActualizada(): void {
    this.validacionFormulariosRevisionSubject.next();
  }

  esNombreFormularioDuplicado(formulario: FormGroup, indexNif: number): boolean {
    const borradores = this.getBorradorGruposPorFirmante(indexNif);
    if (borradores.length === 0) return false;

    const formularioActual = this.encontrarBorradorEnArray(formulario, borradores) ?? formulario;
    const hayDuplicado = this.hayNombreFormularioDuplicadoEnBorradores(formularioActual, borradores);
    if (hayDuplicado) {
      this.mensajeErrorNombreFormulario = 'El nombre del formulario ya existe.';
    }
    return hayDuplicado;
  }

  private isCampoValidoArrayFormulariosPorFormulario(formulario: FormGroup, indexNif: number): boolean {
    const borradores = this.getBorradorGruposPorFirmante(indexNif);
    if (borradores.length === 0) return false;

    const formularioActual = this.encontrarBorradorEnArray(formulario, borradores) ?? formulario;
    const nombreControl = formularioActual.get('nombre');

    if (formularioActual.errors?.nombreFormularioVacio) {
      this.mensajeErrorNombreFormulario = 'El nombre del formulario es requerido.';
    }
    if (formularioActual.errors?.nombreFormularioExiste || nombreControl?.errors?.nombreFormularioExiste) {
      this.mensajeErrorNombreFormulario = 'El nombre del formulario ya existe.';
    }
    if (
      formularioActual.errors?.nombreFormularioExisteEntreFirmantes ||
      nombreControl?.errors?.nombreFormularioExisteEntreFirmantes
    ) {
      const etiqueta = this.obtenerEtiquetaFirmanteConflicto(formularioActual);
      this.mensajeErrorNombreFormulario = etiqueta
        ? `Este nombre ya lo usa ${etiqueta}.`
        : 'El nombre del formulario ya existe en otro firmante.';
    }
    if (formularioActual.errors?.faltanCasillas) {
      this.mensajeErrorNombreFormulario = 'Se tiene que añadir como mínimo un campo en el documento por cada formulario.';
    }

    return !!(
      (formularioActual.errors || nombreControl?.errors) &&
      (formularioActual.touched || nombreControl?.touched)
    );
  }

  private getTodosLosBorradores(): FormGroup[] {
    return (this.formularioDocumentoService.formulariosBorradorFormArray?.controls ?? []).map(
      control => control as FormGroup
    );
  }

  private tieneErrorNombreFormularioDuplicado(
    formulario: FormGroup,
    nombreControl: ReturnType<FormGroup['get']> | null | undefined
  ): boolean {
    return !!(
      formulario.errors?.nombreFormularioExiste ||
      nombreControl?.errors?.nombreFormularioExiste ||
      formulario.errors?.nombreFormularioExisteEntreFirmantes ||
      nombreControl?.errors?.nombreFormularioExisteEntreFirmantes
    );
  }

  private getBorradorGruposPorFirmante(indexNif: number): FormGroup[] {
    const firmanteNif = this.formularioDocumentoService.firmantesNif.at(indexNif) as FormGroup;
    const codigo = firmanteNif?.get('tipoFirmante')?.value?.codigo;
    if (!codigo) {
      return [];
    }
    return this.formularioDocumentoService.getBorradorFormGroupsForFirmante(codigo);
  }

  private encontrarBorradorEnArray(formulario: FormGroup, borradores: FormGroup[]): FormGroup | null {
    const idNombreActual = formulario.get('idNombreFormulario')?.value;
    const nombreActual = this.normalizarNombreFormulario(formulario.get('nombre')?.value);

    const encontrado = borradores.find((fg) => {
      if (idNombreActual != null) {
        return fg.get('idNombreFormulario')?.value === idNombreActual;
      }
      return this.normalizarNombreFormulario(fg.get('nombre')?.value) === nombreActual;
    });

    return encontrado ?? null;
  }

  private hayNombreFormularioDuplicadoEnBorradores(
    formularioActual: FormGroup,
    borradores: FormGroup[]
  ): boolean {
    const nombreActual = this.normalizarNombreFormulario(formularioActual.get('nombre')?.value);
    if (!nombreActual) return false;

    const idNombreFormularioActual = formularioActual.get('idNombreFormulario')?.value;

    return borradores.some((formulario) => {
      const nombre = this.normalizarNombreFormulario(formulario.get('nombre')?.value);
      if (!nombre || nombre !== nombreActual) return false;
      const mismoGrupo =
        idNombreFormularioActual != null &&
        formulario.get('idNombreFormulario')?.value === idNombreFormularioActual;
      return !mismoGrupo;
    });
  }

  private normalizarNombreFormulario(nombre: unknown): string {
    if (nombre == null) return '';
    return nombre
      .toString()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase();
  }

  private addError(control: any, errorKey: string): void {
    const errores = control.errors || {};
    if (errores[errorKey]) return;
    control.setErrors({ ...errores, [errorKey]: true });
  }

  private removeError(control: any, errorKey: string): void {
    const errores = control.errors;
    if (!errores || !errores[errorKey]) return;
    const { [errorKey]: _, ...resto } = errores;
    control.setErrors(Object.keys(resto).length > 0 ? resto : null);
  }

}
